@if (hasOverlappedBackgroundBlock) {
  <div class="absolute left-0 mr-0 h-inherit w-16 {{ backgroundColor }} {{ borderBottom }}"></div>
}

<section class="flex-1 inline-flex items-center gap-x-3">
  @if (hasLeftContent) {
    <div class="left-content-wrapper flex items-center mr-15">
      @if (hasBackButton) {
        <app-icon-button
          data-test-id="go-back-button"
          class="back-btn"
          placement="right"
          tooltipClass="default-tooltip ml-1"
          [type]="'basic'"
          [svgIconPath]="'arrow-single'"
          [ngbTooltip]="backButtonTooltipText && tooltipText"
          [keepOnHover]="true"
          (click)="goBack()"
        ></app-icon-button>
        <div class="w-px h-7.5 bg-navy-50 mr-3.5"></div>
      }

      @if (svgIcon) {
        <svg-icon class="w-9.5 h-9.5" [src]="svgIcon"></svg-icon>
      }

      @if (title) {
        @if (!isTitleTemplate) {
          <span
            class="title"
            [class.ml-3.5]="svgIcon"
            [class.truncate]="shouldTruncateTitle"
            [class.max-w-55]="shouldTruncateTitle"
            [class.w-55]="shouldTruncateTitle"
            [ngbTooltip]="title"
            [openTooltipWhenOverflowedAndHovered]="true"
            [openOnWidthOverflow]="true"
            [placement]="'bottom'"
          >
            {{ title }}
            @if (titleSuffix) {
              <span class="title-suffix">{{ titleSuffix }}</span>
            }
          </span>
        } @else {
          <div class="title">
            <ng-container [ngTemplateOutlet]="$any(title)"></ng-container>
          </div>
        }
      }

      @if (titleRightBorder) {
        <div class="w-px h-7.5 bg-navy-50 ml-3.5"></div>
      }
    </div>
  }

  <ng-content select="[place=left]"></ng-content>
</section>

<ng-content></ng-content>

<ng-template #tooltipText>
  <app-text class="mr-1" [text]="backButtonTooltipText"></app-text>
</ng-template>
